import { combineReducers } from "@reduxjs/toolkit";
import homeReducer from "./homeSlice";
import bookingWidgetReducer from "./bookingWidgetSlice";
import promotionReducer from "./promotionSlice";
import headerReducer from "./header/header-slice";
import footerReducer from "./footerSlice";
import preferenceReducer from "./preferenceSlice";
import ropReducer from "./ropSlice";
import modalSlice from "./modalSlice";
import geolocationSlice from "./header/geolocationSlice";
import countrySlice from "./header/countrySlice";
import rohSlice from "./rohSlice";
import thaiCardApplicationSlice from "./thaiCardApplicationSlice";
import advertisementSlice from "./advertisementSlice";
import privilegeSlice from "./privilegeSlice";
import adCarouselReducer from "./adCarouselSlice";
import sawasdeeMagSlice from "./sawasdeeMagSlice";
import ropMemberJoinReducer from "./ropMemberJoinSlice";
import signUpReducer from "./signUpSlice";
import notificationSliceReducer from "./notificationSlice";
import promotionCardReducer from "./promotionCardSlice";
import offersAndPromotionSlice from "./offerAndPartnersSlice";
import appStoreSlice from "./appStoreSlice";
import loginSlice from "./loginSlice";
import corporateLoginSlice from "./corporateLoginSlice";
import otpSlice from "./otpSlice";
import resetReducer from "./resetSlice";
import moreServicesReducer from "./moreServicesSlice";
import flightInfoSlice from "./flightInfoSlice";
import promoCodeSlice from "./promoCode-Slice";
import resendOTPReducer from "./resendSlice";
import globalSearchReducer from "./globalSearchSlice";
import additionalServiceSlice from "./additionalServiceSlice";
import tripSlice from "./tripSlice";
import crmLoginReducer from "./crmLoginSlice";
import redemptionSlice from "./redemptionSlice";
import ropSignUpSlice from "./ropSignUpSlice";
import fetchProfileSlice from "./fetchProfileSlice";
import newsAnnouncementReducer from "./newsSlice";
import resetCRMSlice from "./resetCRMSlice";
import fetchNomineeSlice from "./fetchNomineeSlice";
import flightFareSlice from "./flightFareSlice";
import unsubscribeSlice from "./unsubscribeSlice";
import subscribeSlice from "./subscribeSlice";
import reSubscribeSlice from "./resubscribeSlice";
import idCarouselReducer from "./idCarouselSlice";
import languageSliceReducer from "./languageSlice";
import crmSignUpReducer from "./crmSignUpSlice";
import socialMediaSlice from "./socialMediaSlice";
import flightStatusSlice from "./flightStatusSlice";
import flightStatusRouteSlice from "./flightRouteStatusSlice";
import logOutReducer from "./logOutSlice";
import preferenceFromSlice from "./newsletterPreferenceSlice";
import profileContactInfoSlice from "./profileContactInfoSlice";
import fetchMainProfileSlice from "./fetchMainMemberProfileSlice";
import fetchCrmProfileSlice from "./fetchCrmProfileSlice";
import fetchMainMemberMilesSlice from "./fetchMilesSlice";
import crmOTPSlice from "./crmOTPSlice";
import pnrDetailsSlice from "./pnrDetailsSlice";
import calendarPricingSlice from "./calendarPricingSlice";
import airAwardBookingSlice from "./airAwardBookingSlice";
import airAwardPnrSlice from "./airAwardPnrSlice";
import airAwardPriceSlice from "./airAwardPriceSlice";
import airAwardTstSlice from "./airAwardTstSlice";
import retrivePNRSlice from "./retrivePNRSlice";
import cancelBookingPNRSlice from "./cancelBookingPNRSlice";
import myProfileDeailsSlice from "./fetchLifeStyleSlice";
import profileLifeStyleSlice from "./profileLifeStyleSlice";
import airAwardReviewPnrSlice from "./airAwardReviewPnrSlice";
import deleteTripCardSlice from "./deleteTripCardSlice";
import airAwardAirportSlice from "./airAwardAirportSlice";
import profilePersonalInfoSlice from "./profilePersonalInfoSlice";
import errorModalSlice from "./errorModalSlice";
import changePasswordSlice from "./changePasswordSlice";
import changePasswordOTPSlice from "./changePasswordOTPSlice";
import changePasswordOTPResendSlice from "./changePasswordOTPResendSlice";
import mileageStatementSlice from "./mileageStatementSlice";
import crmResendOTPSlice from "./crmResendOTPSlice";
import eReceiptSlice from "./eReceiptSlice";
import airAwardReviewPnrRMSlice from "./airAwardReviewPnrRMSlice";
import loginPanelSlice from "./loginPanelSlice";
import myTripsSlice from "./myTripsSlice";
import airAwardReviewPnrCancelSlice from "./airAwardReviewPnrCancelSlice";
import backTrackingAirportSlice from "./backTrackingAirportSlice";
import helpSlice from "./header/helpSlice";
import airAwardPaymentInitSlice from "./airAwardPaymentInitSlice";
import addNomineeSlice from "./addNomineeSlice";
import memberStatusCalculatorSlice from "./fetchMemberStatusCalculatorSlice";
import extendExpiryMilesSlice from "./fetchExtendExpiryMileSlice";
import giftMilesSlice from "./giftMilesSlice";
import claimMissingMilesSlice from "./claimMissingMilesSlice";
import baggageAllowanceSlice from "./baggageAllowanceSlice";
import airAwardConfirmationSlice from "./airAwardConfirmationSlice";
import mileagePurchaseSlice from "./mileagePurchaseSlice";
import transferMilesSlice from "./transferMilesSlice";
import earnedMilesSlice from "./earnedMilesSlice";
import redeemMilesSlice from "./redeemMilesSlice";
import excessBaggageSlice from "./excessBaggageSlice";
import airLineListSlice from "./starAllianceAirlineListSlice";
import upgradeSeatSlice from "./upgradeSeatSlice";
import extraBaggageAllowanceSlice from "./extraBaggageAllowanceSlice";
import partnerReducer from "./partnerSlice";
import starAllianceRedemptionSlice from "./starAllianceRedemptionSlice";
import boardingPassSlice from "./boardingPassSlice";
import crmChangePasswordSlice from "./crmChangePasswordSlice";
import crmChangePasswordOTPSlice from "./crmChangePasswordOTPSubmitSlice";
import crmChangePasswordOTPResendSlice from "./crmChangePasswordOTPResendSlice";
import myThaiCRMFormSlice from "./myThaiCRMFormSlice";
import charterRequestFormSlice from "./charterRequestFormSlice";
import myThaiMyRequestsSlice from "./myThaiMyRequestsSlice";
import helpFaqSlice from "./helpFaqSlice";
import baggageTrackingSlice from "./baggageTrackingSlice";
import crmServiceRequestSlice from "./crmServiceRequestSlice";
import searchByMilesSlice from "./searchByMilesSlice";
import tripsSlice from "./allTripsSlice";
import flightDisruptionCertSlice from "./flightDisruptionSlice";
import baggageClaimSlice from "./baggageClaimSlice";
import crmLostFound from "./crmLostFoundSlice";
import flightUpgradeinfoSlice from "./flightupgradeinformation";
import preSelectMealSlice from "./preSelectMealSlice";
import mealsListSlice from "./mealsListSlice";
import metaTagsSlice from "./metaTagsSlice";
import travelClassFormSlice from "./travelClassSlice";
import miceOffersSlice from "./addMiceOffersSlice";
import preSelectSubmitSlice from "./preSelectMealSubmitSlice";
import popularFareSlice from "./popularFareSlice";
import goldtrackinfoSlice from "./goldtrackSlice";
import loungeinfoSlice from "./loungeFinderSlice";
import marketSlice from "./marketListSlice";
import tokenExpire from "./tokenExpiredSlice";
import flightSchedule from "./flightScheduleSlice";
import verifymail from "./newsletterVerifyEmailSlice";
import baggageDamageClaimSlice from "./baggageDamageClaimSlice";
import compensationRequestSlice from "./compensationRequestSlice";
import refundAirFareFeeSlice from "./refundAirFareFeeSlice";
import governmentBookingSlice from "./governmentBookingSlice";
import bookingMarketRolloutSlice from "./bookingMarketRolloutSlice";
import tripWeatherInfoSlice from "./tripWeatherInfoSlice";
import orderRetrieveSlice from "./orderRetrieveSlice";
import mmbErrorCodeSlice from "./header/mmbErrorCodeSlice";
import mmbMarketRolloutSlice from "./mmbMarketRolloutSlice";
import governmentReportsSlice from "./governmentBookingReport";
import corporateagencytokenExpiredSlice from "./corporateagencytokenExpiredSlice";
import shoppingCartSlice from "./shoppingCartSlice";
import settingsReducer from "../../../OSCI/src/slice/settingsSlice";
import resetCorporateSlice from "./resetCorporateSlice";
import usersReducer from "./userList";
import ropEnabledSlice from "./ropEnablementSlice";
import forgotMemberIdSlice from "./forgotMemberIdSlice";
const RootReducer = combineReducers({
  home: homeReducer,
  header: headerReducer,
  footer: footerReducer,
  promotionData: promotionReducer,
  ropData: ropReducer,
  bookingWidget: bookingWidgetReducer,
  preference: preferenceReducer,
  modals: modalSlice,
  geolocation: geolocationSlice,
  country: countrySlice,
  rohData: rohSlice,
  thaicard: thaiCardApplicationSlice,
  advertisement: advertisementSlice,
  privilegeData: privilegeSlice,
  adCarousel: adCarouselReducer,
  swMagzine: sawasdeeMagSlice,
  ropmemberjoin: ropMemberJoinReducer,
  signUp: signUpReducer,
  notification: notificationSliceReducer,
  promotionCard: promotionCardReducer,
  offersAndPromotion: offersAndPromotionSlice,
  app: appStoreSlice,
  loginData: loginSlice,
  corporateLoginData: corporateLoginSlice,
  otpData: otpSlice,
  reset: resetReducer,
  moreServices: moreServicesReducer,
  promoCode: promoCodeSlice,
  resendOTPData: resendOTPReducer,
  globalSearch: globalSearchReducer,
  additonalService: additionalServiceSlice,
  trips: tripSlice,
  crmLoginData: crmLoginReducer,
  redemption: redemptionSlice,
  ropSignup: ropSignUpSlice,
  charterRequestForm: charterRequestFormSlice,
  profile: fetchProfileSlice,
  flightInfo: flightInfoSlice,
  crmReset: resetCRMSlice,
  news: newsAnnouncementReducer,
  nominee: fetchNomineeSlice,
  addNominee: addNomineeSlice,
  flightFare: flightFareSlice,
  idCarousel: idCarouselReducer,
  languageSlice: languageSliceReducer,
  crmSignUp: crmSignUpReducer,
  socialMedia: socialMediaSlice,
  unsubscribeReset: unsubscribeSlice,
  subscribeReset: subscribeSlice,
  resubscribeReset: reSubscribeSlice,
  flightStatus: flightStatusSlice,
  flightStatusRoute: flightStatusRouteSlice,
  logout: logOutReducer,
  preferenceFrom: preferenceFromSlice,
  goldtrackinfo: goldtrackinfoSlice,
  loungeInfo: loungeinfoSlice,
  crmotpData: crmOTPSlice,
  profileContactInfo: profileContactInfoSlice,
  MyProfileDeails: fetchMainProfileSlice,
  pnr: pnrDetailsSlice,
  dateFare: calendarPricingSlice,
  MyProfileMilesDeails: fetchMainMemberMilesSlice,
  airAwardBooking: airAwardBookingSlice,
  airAwardPnr: airAwardPnrSlice,
  airAwardPrice: airAwardPriceSlice,
  airAwardTst: airAwardTstSlice,
  retrivePNRData: retrivePNRSlice,
  cancelBookingPNRData: cancelBookingPNRSlice,
  myLifeStyleData: myProfileDeailsSlice,
  profileLifeStyleSubmitResponse: profileLifeStyleSlice,
  airAwardReviewPnr: airAwardReviewPnrSlice,
  deleteTripCard: deleteTripCardSlice,
  airAwardAirport: airAwardAirportSlice,
  profilePersonalInfo: profilePersonalInfoSlice,
  fetchCrmMemberProfile: fetchCrmProfileSlice,
  errorModal: errorModalSlice,
  changePassword: changePasswordSlice,
  changePasswordotpData: changePasswordOTPSlice,
  changePasswordResend: changePasswordOTPResendSlice,
  mileageStatement: mileageStatementSlice,
  crmResendOTPData: crmResendOTPSlice,
  eReceipt: eReceiptSlice,
  airAwardReviewPnrRM: airAwardReviewPnrRMSlice,
  loginPanel: loginPanelSlice,
  myTrips: myTripsSlice,
  airAwardReviewPnrCancel: airAwardReviewPnrCancelSlice,
  backTrackingAirport: backTrackingAirportSlice,
  help: helpSlice,
  airAwardPayment: airAwardPaymentInitSlice,
  memberStatusCalculator: memberStatusCalculatorSlice,
  extendExpiryMile: extendExpiryMilesSlice,
  giftMiles: giftMilesSlice,
  mileagePurchase: mileagePurchaseSlice,
  claimMiles: claimMissingMilesSlice,
  baggageAllowance: baggageAllowanceSlice,
  airAwardConfirmation: airAwardConfirmationSlice,
  transferMiles: transferMilesSlice,
  earnedMiles: earnedMilesSlice,
  redeemMiles: redeemMilesSlice,
  excessBaggage: excessBaggageSlice,
  starAirLineList: airLineListSlice,
  upgradeSeat: upgradeSeatSlice,
  airLineList: airLineListSlice,
  extraBaggageAllowance: extraBaggageAllowanceSlice,
  partner: partnerReducer,
  starAllianceRedemption: starAllianceRedemptionSlice,
  boardingPass: boardingPassSlice,
  crmChangePassword: crmChangePasswordSlice,
  crmChangePasswordOTP: crmChangePasswordOTPSlice,
  crmChangePasswordOTPResend: crmChangePasswordOTPResendSlice,
  myThaiCRMForm: myThaiCRMFormSlice,
  helpFaq: helpFaqSlice,
  baggageTracking: baggageTrackingSlice,
  crmRequestService: crmServiceRequestSlice,
  searchByMiles: searchByMilesSlice,
  myThaiMyRequests: myThaiMyRequestsSlice,
  allTrips: tripsSlice,
  flightDisruptionCert: flightDisruptionCertSlice,
  baggageClaim: baggageClaimSlice,
  crmLostFoundService: crmLostFound,
  flightupgradeinfo: flightUpgradeinfoSlice,
  preSelectMeals: preSelectMealSlice,
  mealsList: mealsListSlice,
  metaTags: metaTagsSlice,
  travelClassForm: travelClassFormSlice,
  miceOffers: miceOffersSlice,
  preselectSubmit: preSelectSubmitSlice,
  popularFare: popularFareSlice,
  market: marketSlice,
  tokenExpire: tokenExpire,
  flightSchedule: flightSchedule,
  verifymail: verifymail,
  baggageDamageClaim: baggageDamageClaimSlice,
  compensationRequest: compensationRequestSlice,
  refundAirFareFeeRequest: refundAirFareFeeSlice,
  governmentBooking: governmentBookingSlice,
  bookingMarketRollout: bookingMarketRolloutSlice,
  tripWeatherInfoSlice: tripWeatherInfoSlice,
  orderRetrieve: orderRetrieveSlice,
  mmbErrorCodes: mmbErrorCodeSlice,
  mmbMarketRollout: mmbMarketRolloutSlice,
  addShoppingCart: shoppingCartSlice,
  settings: settingsReducer,
  resetCorporate: resetCorporateSlice,
  users: usersReducer,
  ropEnable: ropEnabledSlice,
  forgotMemberId: forgotMemberIdSlice,
  governmentBookingReports: governmentReportsSlice,
  corporateagencytokenExpiredSlice: corporateagencytokenExpiredSlice
});
export default RootReducer;